<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add URL</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="urlSelected" (change)="onUrlKeyChange($event.target.selectedIndex)">
        <option *ngFor="let url of urlArr" [value]="url.id">{{url.name}}</option>
      </select>
    </div>
    <div class="form-group" *ngIf = "showurl"> 
        <input type="text" class="form-control radius-0 font-13" placeholder="URL Name" readonly
               [(ngModel)]="url">
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>
    <div class="form-group matFrom">
        <mat-form-field>
          <mat-label class="font-13">Select support group</mat-label>
          <mat-select [(ngModel)]="sgroupSelected" multiple>
            <mat-option *ngFor="let group of support_group" [value]="group.id" class="font-13">{{group.name}}</mat-option>
          </mat-select>
        </mat-form-field>
  
      </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>
